import { fmtDate } from '../../utils/ruDates';
function TaskKanban({
    kanbanColumns,
    kanbanGroup,
    companyUsers,
    getUserLabel,
    getInitials,
    onOpenTask,
    onDragStart,
    onDrop
}) {
    return (
        <div className="kanban">
            {kanbanColumns.map((column) => (
                <div
                    key={column.key}
                    className={`kanban__column ${`kanban__column--${column.key}`}`}
                    onDragOver={(event) => {
                        event.preventDefault();
                        event.dataTransfer.dropEffect = 'move';
                    }}
                    onDrop={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onDrop(event, column.key);
                    }}
                >
                    <div className="kanban__head">
                        <h5>{column.title}</h5>
                        <span>{column.tasks.length}</span>
                    </div>
                    <div className="kanban__cards">
                        {column.tasks.map((task) => (
                            <div
                                key={task.id}
                                className="kanban__card"
                                draggable
                                onDragStart={(event) => onDragStart(event, task.id)}
                                onClick={() => onOpenTask(task.id)}
                            >
                                <div className="kanban__title" title={task.title}>
                                    {task.title}
                                </div>
                                <div className="kanban__people">
                                    {(() => {
                                        const assignee = companyUsers.find(
                                            (item) => item.id === task.assignee_id
                                        );
                                        const creator = companyUsers.find(
                                            (item) => item.id === task.created_by_id
                                        );
                                        if (!assignee && !creator) {
                                            return <span className="muted">—</span>;
                                        }

                                        return (
                                            <>
                                                {assignee && (
                                                    <a
                                                        href={`/users/${assignee.id}`}
                                                        className="kanban__avatar"
                                                    >
                                                        {getInitials(assignee)}
                                                    </a>
                                                )}
                                                <div className="kanban__names">
                                                    {creator && (
                                                        <span>Постановщик: {getUserLabel(creator)}</span>
                                                    )}
                                                    {assignee && (
                                                        <span>Исполнитель: {getUserLabel(assignee)}</span>
                                                    )}
                                                </div>
                                            </>
                                        );
                                    })()}
                                </div>
                                <div className="kanban__meta">
                                    {task.due_at ? fmtDate(task.due_at) : 'Без срока'}
                                </div>
                                <div className="kanban__chips">
                                    {(task.tags || []).map((tag) => (
                                        <span key={tag} className="chip">
                                            {tag}
                                        </span>
                                    ))}
                                    {task.overdue && <span className="chip chip--danger">Просрочено</span>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TaskKanban;
